// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require("es6-promise").polyfill();
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "./assets/axios/index.js";
import "./assets/styles/reset.css"
import "./assets/styles/mandMobileUi.css"
import "mint-ui/lib/style.css";

// import 'mand-mobile/lib/mand-mobile.css'

Vue.prototype.$axios = axios;

Vue.use(require("vue-wechat-title"));


Vue.config.productionTip = false;

const script = document.createElement("script");
let gioId = "ac853984fcde2e20"; // ac853984fcde2e20 gio 测试环境  8a280edd3fe6d7e0 gio 生产环境
window.location.hostname == "active.feihe.com"
    ? (gioId = "8a280edd3fe6d7e0")
    : (gioId = "ac853984fcde2e20");
script.text = `!(function(e, t, n , g , i ) {
        (e[i] =
            e[i] ||
            function() {
                (e[i].q = e[i].q || []).push(arguments);
            }),
            (n = t.createElement('script')),
            (tag = t.getElementsByTagName('script')[0]),
            (n.async = 1),
            (n.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + g),
            tag.parentNode.insertBefore(n, tag);
    })(window, document, 'script', 'assets.growingio.com/2.1/gio.js', 'gio');
    gio('init', '${gioId}', {});
    gio('config', {'hashtag':true}); //放在init和send之间
    gio('send');`;

document.body.appendChild(script);

//监听storage的变化
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'renderWidth') {

      // 创建一个StorageEvent事件
      var newStorageEvent = document.createEvent('StorageEvent');
      const storage = {
          setItem: function (k, val) {
              sessionStorage.setItem(k, val);

              // 初始化创建的事件
              newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

              // 派发对象
              window.dispatchEvent(newStorageEvent)
          }
      }
      return storage.setItem(key, newVal);
  }
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js